import React from 'react';
import { Chip } from '@infoods/lifebase-ui';

type CustomerAccountInfoProps = {
  inbodyAccountId: number | null;
};

export const CustomerAccountInfo = ({ inbodyAccountId }: CustomerAccountInfoProps) => {
  return inbodyAccountId ? (
    <Chip label="Account is created" color="success" size="medium" />
  ) : (
    <Chip label="No Account" color="default" size="medium" />
  );
};
